import { Injectable, signal } from '@angular/core';

const COLLAPSED_KEY = 'sas-sidebar-collapsed';

@Injectable({ providedIn: 'root' })
export class SasMenuService {
  private _collapsed = signal(localStorage.getItem(COLLAPSED_KEY) !== 'false');
  private _hidden = signal(true);
  private _mobileOpen = signal(false);

  readonly collapsed = this._collapsed.asReadonly();
  readonly hidden = this._hidden.asReadonly();
  readonly mobileOpen = this._mobileOpen.asReadonly();

  toggle() {
    this._collapsed.update(v => !v);
    localStorage.setItem(COLLAPSED_KEY, String(this._collapsed()));
  }

  show() {
    this._hidden.set(false);
  }

  hide() {
    this._hidden.set(true);
  }

  toggleMobile() {
    this._mobileOpen.update(v => !v);
  }

  closeMobile() {
    this._mobileOpen.set(false);
  }
}
